var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.015,
    height: 28.015,
    viewBox: "0 0 28.015 28.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    fill: "rgba(255, 255, 255, 0.40)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M10.8,9.339H2.043A2.045,2.045,0,0,1,0,7.3V2.043A2.045,2.045,0,0,1,2.043,0H10.8A2.045,2.045,0,0,1,12.84,2.043V7.3A2.045,2.045,0,0,1,10.8,9.339ZM2.043,1.751a.292.292,0,0,0-.292.292V7.3a.292.292,0,0,0,.292.292H10.8a.292.292,0,0,0,.292-.292V2.043a.292.292,0,0,0-.292-.292Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M10.8,229.674H2.043A2.045,2.045,0,0,1,0,227.632V215.375a2.045,2.045,0,0,1,2.043-2.043H10.8a2.045,2.045,0,0,1,2.043,2.043v12.257A2.045,2.045,0,0,1,10.8,229.674ZM2.043,215.083a.292.292,0,0,0-.292.292v12.257a.292.292,0,0,0,.292.292H10.8a.292.292,0,0,0,.292-.292V215.375a.292.292,0,0,0-.292-.292Zm0,0",
    transform: "translate(0 -201.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M288.13,350.671h-8.755a2.045,2.045,0,0,1-2.043-2.043v-5.253a2.045,2.045,0,0,1,2.043-2.043h8.755a2.045,2.045,0,0,1,2.043,2.043v5.253A2.045,2.045,0,0,1,288.13,350.671Zm-8.755-7.587a.292.292,0,0,0-.292.292v5.253a.292.292,0,0,0,.292.292h8.755a.292.292,0,0,0,.292-.292v-5.253a.292.292,0,0,0-.292-.292Zm0,0",
    transform: "translate(-262.157 -322.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M288.13,16.342h-8.755a2.045,2.045,0,0,1-2.043-2.043V2.043A2.045,2.045,0,0,1,279.375,0h8.755a2.045,2.045,0,0,1,2.043,2.043V14.3A2.045,2.045,0,0,1,288.13,16.342ZM279.375,1.751a.292.292,0,0,0-.292.292V14.3a.292.292,0,0,0,.292.292h8.755a.292.292,0,0,0,.292-.292V2.043a.292.292,0,0,0-.292-.292Zm0,0",
    transform: "translate(-262.157)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.6c6c02d9.svg";
export { ForwardRef as ReactComponent };